<template>
  <div class="w98">
   <div class="crumb">
      <span><router-link to="/Help">帮助</router-link>  > </span>
      <span>软件概述</span>
    </div>
     <help-Menu></help-Menu>
    <div class="rightContent">
      <div class="softMessage">
          <p class="text">本软件是一款功能强大的远程医学影像教育系统软件,可直接从基于电脑或Pad的网页中进行访问。产品由本院影像、典型病例库、教学课件、读片管理、教学管理和教学中心六大功能组成。</p>
          <p class="text">
            本院影像模块主要用于影像调阅、报告查看及历史报告对比，支持一键收藏到病例库；典型病例库用于支持临床病例和医学影像病例收集、分类、查询、浏览。
            可以从医院信息系统中集成所需临床数据，并经过患者信息隐私保护处理，同时配合专业的图像和波形等诊断工具，完全模拟真实的临床使用环境。
            读片管理模块可以在本院范围内或者医联体范围内实时在线直播影像读片示教会议，供科室或者其他医院医生观摩学习。
            在线参与读片会议的医生可以通过本院影像方便地获取读片会议资料，包括读片引用影像的获取和浏览，并能通过读片管理系统中视频、桌面共享和程序共享的方式进行直播。
            教学管理是教师用来授课的，上课实现教师对课程的管理和教案的管理，课程集成了视频技术及病例资料。教学中心服务于学员，为学员提供两种远程课程。
            直播授课课程，实时交互培训支持授课专家音视频与课件播放同步。
            自主学习课程，学员通过点播课程，自主完成实现文字、幻灯，包括临床相关资料等课件网上在线学习。
          </p>
           <p class="text">
            DICOM浏览器模块支持在线查看医学放射影像，具有便捷的搜索界面、协作和高级显像，功能包括：2D 查看；最大强度投影（MIP，包括长达50 毫米的投影块）；轴向、矢状和冠状的多层面重建 (MPR)；3D 体积渲染。
            每个查看模式均可让您与影像、数据和报告进行互动（例如，拆分视图和链接滚动、电影、平移和缩放、注释和度量）。
          </p>
     </div>

    </div>
</div>
</template>

<script type="text/ecmascript-6">
  import {getRightHeight} from '@/common/js/rightHeight'
  import helpHead from '@/components/common/header/helpHead'
  import helpMenu from '@/components/common/helpMenu/helpMenu'
  export default {
    data () {
      return {
         height:'',
         activeNames: ''
      }
    },
    components:{
        helpHead,
        helpMenu
    },
      mounted() {
      setTimeout(() => {
//        this._getRightW()
        getRightHeight('rightContent', this.height)
      }, 20)
      window.addEventListener('resize', () => {
//        this._getRightW()
        getRightHeight('rightContent', this.height)
      })
    },
    methods:{
        handleChange(val) {
       // console.log(val);
      }
    }
}

</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.content
    min-width: 100vw
    height: 100vh
    overflow: hidden
    .rightContent
      position: relative
      float: right
      height :calc(100vh - 80px)
      width: calc(80% - 1px)
      min-width: 919px
      background :#fff
 .crumb
 line-height: 30px
 margin: 5px 0 0 20px
.softMessage
  padding:50px
  line-height:25px
 .text
   color:#555
   line-height: 25px
   text-indent:2em
</style>



// WEBPACK FOOTER //
// Software.vue?98693740